import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { setAuthToken, setAuthData } from '../../../utils/auth';

const LinkedInRedirect = () => {
  const navigate = useNavigate();

  // Function to parse URL and extract token and user details
  const parseUrlParams = () => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const firstName = params.get('firstName');
    const lastName = params.get('lastName');
    const email = params.get('email');

    // Construct userDetails object if available
    const userDetails = firstName && lastName && email ? { firstName, lastName, email } : null;
    return { token, userDetails };
  };

  useEffect(() => {
    const { token, userDetails } = parseUrlParams();

    if (token && userDetails) {
      // Store token and user details
      // setAuthToken(token);
      // setAuthData(userDetails);
  const storageType = "local";
       setAuthToken(token, storageType);
       setAuthData(userDetails, storageType);
      // Show success notification
      toast.success('Logged in successfully.');

      // Redirect to homepage or any other page
      navigate('/');
    } else {
      // Handle the case where token or userDetails are missing
      toast.error('Login failed. Please try again.');
      navigate('/login'); // Redirect to login page if required
    }
  }, [navigate]); // Add `navigate` to dependencies

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>Logging you in...</h1>
    </div>
  );
};

export default LinkedInRedirect;
